import JitsiMeetJS from '../../base/lib-jitsi-meet';
export * from './functions.any';
/**
 * Removes all analytics related options from the given configuration, in case of a libre build.
 *
 * @param {*} _config - The configuration which needs to be cleaned up.
 * @returns {void}
 */
export function _cleanupConfig(_config) {
    return;
}
/**
 * Returns the replaceParticipant config.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean}
 */
export function getReplaceParticipant(state) {
    return state['features/base/config'].replaceParticipant;
}
/**
 * Returns the configuration value of web-hid feature.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean} True if web-hid feature should be enabled, otherwise false.
 */
export function getWebHIDFeatureConfig(state) {
    return state['features/base/config'].enableWebHIDFeature || false;
}
/**
 * Returns whether audio level measurement is enabled or not.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean}
 */
export function areAudioLevelsEnabled(state) {
    return !state['features/base/config'].disableAudioLevels && JitsiMeetJS.isCollectingLocalStats();
}
/**
 * Sets the defaults for deeplinking.
 *
 * @param {IDeeplinkingConfig} deeplinking - The deeplinking config.
 * @returns {void}
 */
export function _setDeeplinkingDefaults(deeplinking) {
    deeplinking.desktop = deeplinking.desktop || {};
    deeplinking.android = deeplinking.android || {};
    deeplinking.ios = deeplinking.ios || {};
    const { android, desktop, ios } = deeplinking;
    desktop.appName = desktop.appName || 'Viettel Meeting';
    desktop.appScheme = desktop.appScheme || 'jitsi-meet';
    desktop.download = desktop.download || {};
    desktop.download.windows = desktop.download.windows
        || 'https://github.com/jitsi/jitsi-meet-electron/releases/latest/download/jitsi-meet.exe';
    desktop.download.macos = desktop.download.macos
        || 'https://github.com/jitsi/jitsi-meet-electron/releases/latest/download/jitsi-meet.dmg';
    desktop.download.linux = desktop.download.linux
        || 'https://github.com/jitsi/jitsi-meet-electron/releases/latest/download/jitsi-meet-x86_64.AppImage';
    ios.appName = ios.appName || 'Viettel Meeting';
    ios.appScheme = ios.appScheme || 'com.viettel.meeting';
    ios.downloadLink = ios.downloadLink
        || 'https://apps.apple.com/us/app/viettel-meeting/id6451429541';
    if (ios.dynamicLink) {
        ios.dynamicLink.apn = ios.dynamicLink.apn || 'com.viettel.meeting';
        ios.dynamicLink.appCode = ios.dynamicLink.appCode || 'w2atb';
        ios.dynamicLink.ibi = ios.dynamicLink.ibi || 'com.atlassian.JitsiMeet.ios';
        ios.dynamicLink.isi = ios.dynamicLink.isi || '1165103905';
    }
    android.appName = android.appName || 'Viettel Meeting';
    android.appScheme = android.appScheme || 'com.viettel.meeting';
    android.downloadLink = android.downloadLink
        || 'https://play.google.com/store/apps/details?id=meeting.atviettelsolutions.com';
    android.appPackage = android.appPackage || 'com.viettel.meeting';
    android.fDroidUrl = android.fDroidUrl || '';
    if (android.dynamicLink) {
        android.dynamicLink.apn = android.dynamicLink.apn || 'com.viettel.meeting';
        android.dynamicLink.appCode = android.dynamicLink.appCode || 'w2atb';
        android.dynamicLink.ibi = android.dynamicLink.ibi || 'com.atlassian.JitsiMeet.ios';
        android.dynamicLink.isi = android.dynamicLink.isi || '1165103905';
    }
}
